import React, {useEffect} from 'react';
import WishlistHeartRecoWrapper from "@wishlist/components/WishlistHeartRecoWrapper.jsx";
import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import {SideSectionAction} from "@product/sections/SideSectionAction.tsx";
import SoldOutRecommendation from "./SoldOutRecommendation.jsx";
import Url from "@core/scripts/helper/url";
import ProductMessages from "../../message-list.js";

export default function SoldOutCarousel({texts, shopId, item}) {
    useEffect(()=>{
        const dataUrl = Url.toAbsolute('/ajax/recommendation/sold-out/');
        const paramString = `?shopId=${shopId}&itemNumber=${item.itemNumber}`;
        const paramStringWithExclusionIds = paramString + '&maxRecommendationSize=16&excludedDigistyleIds=';
        const executeSideSheetLogic = () => {
            const soldOutAvailableAlternatives = (
                <SoldOutRecommendation paramString={paramStringWithExclusionIds}
                                       dataUrl={dataUrl}
                                       className="sold-out-carousel-slider"
                >
                    <WishlistHeartRecoWrapper />
                </SoldOutRecommendation>
            );

            MessageBroker.publish(SideSectionAction.OPEN, {
                nodes: {
                    title: texts['ada_psm_headline'],
                    content: soldOutAvailableAlternatives
                }
            });
        };

        executeSideSheetLogic();

        const subscribe = MessageBroker.subscribe(ProductMessages.OPEN_SIDE_SHEET_FOR_SOLD_OUT_ARTICLE, () => {
            executeSideSheetLogic();
        });

        return () => {
            MessageBroker.unsubscribe(subscribe);
        };
    })
}
